import { Sunrise, Sprout, Footprints, Hourglass, Sparkles, PenLine } from 'lucide-react';

// Starting points for a story. Each names a kind of journey — not everyone has a
// dramatic before/met/now arc. Labels, descriptions, and the prompt copy live in
// i18n under `testimony.templates.<id>.*`; only ids, icon, accent colour, and the
// ordered prompt ids live here. The backend mirrors these ids in TEMPLATE_ARCS.
//
// Every template ends with a shared reflective "heart" prompt (`grace`) so the AI
// always has the spiritual heart — God's love, grace, mercy — to build on, not just
// facts. Shared prompts resolve their copy from `testimony.sharedPrompts.<id>.*`.
export const SHARED_PROMPTS = ['grace'];

export const STORY_TEMPLATES = [
  { id: 'classic',  Icon: Sunrise,    color: '#2563EB', prompts: ['before', 'meeting', 'after', 'grace'] },
  { id: 'deeper',   Icon: Sprout,     color: '#16A34A', prompts: ['upbringing', 'turningPoint', 'nowFaith', 'grace'] },
  { id: 'prodigal', Icon: Footprints, color: '#E8751A', prompts: ['drifting', 'awakening', 'return', 'grace'] },
  { id: 'waiting',  Icon: Hourglass,  color: '#7C3AED', prompts: ['longing', 'wrestling', 'meeting', 'grace'] },
  { id: 'miracle',  Icon: Sparkles,   color: '#CA8A04', prompts: ['need', 'prayer', 'answer', 'grace'] },
  { id: 'freeform', Icon: PenLine,    color: '#475569', prompts: ['part1', 'part2', 'part3', 'grace'] },
];

export const TEMPLATE_BY_ID = Object.fromEntries(STORY_TEMPLATES.map(t => [t.id, t]));

// i18n key prefix for a prompt's copy — shared prompts live in one place, the rest
// under their template. Append `.label` / `.placeholder` / `.example`.
export function promptCopyKey(templateId, promptId) {
  return SHARED_PROMPTS.includes(promptId)
    ? `sharedPrompts.${promptId}`
    : `templates.${templateId}.prompts.${promptId}`;
}
